import React, { useEffect, useState } from "react";

import { Heading, PanelWrapper, ListWrapper } from "./style";

import { replaceCharWith } from "@website-builder/utilities-index";
import { getStoriesByContentType } from "@website-builder/services";
import { contentType, getBlogCategories } from "./transform";
import CtaLink from "../../../../Elements/CtaLink";

const BlogCategories = ({ categoriesMap, header, context }) => {
	const [categoriesMapState, setCategoriesMapState] = useState(categoriesMap);

	useEffect(() => {
		if (process.env.GATSBY_TEMPLATE === "PREVIEW") {
			async function fetchData() {
				const { token } = context;
				let result = await getStoriesByContentType(
					contentType,
					token && token.private,
				);
				result = getBlogCategories(result);
				setCategoriesMapState(result);
			}
			fetchData();
		}
	}, []);

	const renderBlogCategories = () => {
		let categories = Object.keys(categoriesMapState);
		return categories.map((category, index) => {
			return (
				<li key={index}>
					<CtaLink
						value={`/${categoriesMapState[category]["filterSlug"]}`}
						type="external"
						target="_self"
						key={`${index}`}
					>
						{replaceCharWith(/-/g, " ", category)}
					</CtaLink>
				</li>
			);
		});
	};

	return (
		<PanelWrapper>
			<Heading>{header}</Heading>
			<ListWrapper>{renderBlogCategories()}</ListWrapper>
		</PanelWrapper>
	);
};

export default BlogCategories;
